export default __webpack_public_path__ + "static/media/401.49e80bed.jpg";